import styled, { css } from "styled-components"
import Breakpoints from "../shared/breakpoints"
import TextStyles from "../shared/typography.styles"

export const OverlayStyle = css`
  background-color: var(--tricorn-black);
`

export const ContentContainer = styled.div`
  grid-column: 1 / -1;
  display: grid;
  grid-template-columns: 1fr;
  padding: 40px 0 96px 0;

  @media (min-width: ${Breakpoints.md}) {
    grid-column: 2 / -2;
    padding: 48px 0;
  }
  @media (min-width: ${Breakpoints.lg}) {
    padding: 88px 0 96px 0;
  }
`

export const Spacer = styled.div`
  display: none;

  @media (min-width: ${Breakpoints.lg}) {
    display: block;
  }
`

export const SectionTitle = styled.h2`
  ${TextStyles.mobileTextStyles.MobileHeadingTwoSemiBold}
  color: var(--dark-mode-body-grey);
  text-align: center;
  align-self: center;

  grid-column: 2 / -2;
  margin-top: 64px;
  padding-bottom: 24px;
  border-bottom: 1px solid #f2f2f266;

  @media (min-width: ${Breakpoints.md}) {
    ${TextStyles.tabletTextStyles.TabletHeadingTwoSemiBold}
    margin-top: 48px;
    grid-column: 3 / -3;
    padding-bottom: 16px;
    border-bottom: 1px solid #f2f2f266;
  }
  @media (min-width: ${Breakpoints.lg}) {
    ${TextStyles.desktopTextStyles.HeadingTwoSemiBold}
    margin-top: 96px;
    padding-bottom: 32px;
    border-bottom: 0px;
  }
`
